<template>
    <div class="game-tester">
        <div style="display:none">{{ updateColor() }}</div>

        <div id="tester-info">
            <img id="tester-avatar" :src="pic" alt="avatar">
            
            <div class="tester-details">
                <div id="tester-name">{{ name }}</div>
                <div id="tester-achieve">Achievements: {{ achievementsCompleted }}</div>
            </div>

            <div v-if="hasButton" class="add-tester-item-btn" @click="addTester">
                Add
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from '../loading/index.vue'
    import PlayTesterUser from "../../Firestore/PlayTesterUser";
    import { db } from '../../db.js';
    import API_URL from '../../api/config.js'
    
    export default {
        name: "addTesterItem",
        components: { Loading },
        props: {
            id: String,
            pic: { type: String, default: require("../../assets/avatar_default.png") },
            name: { type: String, default: "TESTER NAME" },
            email: { type: String, default: "tester@gmail.com" },
            achievementsCompleted: { type: Number, default: 0 },
            gameId: String,
            hasButton: { type: Boolean, default: true }
        },
        data() {
            return {
                userType: -1,
                isLoading: false,
            }
        },
        mounted() {
            this.userType = parseInt(window.localStorage.getItem("userType"));
        },
        methods: {
            async addTester() {
                this.isLoading = true;

                try{
                    await PlayTesterUser.createTester(this.gameId, this.id);
                    this.$emit('addTester');
                    
                    //
                    const gameDoc = await db.collection("Game").doc(this.gameId).get();
                    const name = gameDoc.data().gameName;
                    const message = gameDoc.data().company;

                    //send email to notify the user
                    console.log(this.id);
                    const response = await fetch(`${API_URL}/email/testers/${this.id}/playtest-notif`, {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({name, message})
                    })
                    
                    const data = await response.json();

                    if (!data.success) {
                        throw new Error(data.error || "Failed sending email")
                    }
                    console.log("User recieved email");
                } catch (error) {
                    console.error('Error adding tester:', error);
                    alert(error.message || 'Something went wrong');
                } finally {
                    this.isLoading = false;
                }
            }, 
            updateColor() {
                const r = document.querySelector(':root');
                if(r) {
                    r.style.setProperty('--GAMETESTERB', this.$store.state.gametesterb);
                    r.style.setProperty('--VIEWRES', this.$store.state.viewres);
                }
            },
        }
    }
</script>

<style scoped>
.game-tester {
    background-color: #fbfbfb;
    border: 1px solid #eee;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.game-tester:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

#tester-info {
    display: flex;
    align-items: center;
    gap: 15px;
    position: relative;
}

#tester-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    background: #eee;
}

.tester-details {
    flex: 1;
    min-width: 0; /* Prevents text overflow issues in flex */
}

#tester-name {
    font-weight: 700;
    font-size: 14px;
    color: #FC7727;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#tester-email {
    font-size: 11px;
    color: #666;
    margin-bottom: 4px;
}

#tester-achieve {
    font-size: 11px;
    font-weight: 600;
    color: #888;
}

.add-tester-item-btn {
    padding: 6px 14px;
    background: #FC7727;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
}

.add-tester-item-btn:hover {
    background: #ff8e4d;
}
</style>


// WEBPACK FOOTER //
// src/components/game-detail/AddTesterItem.vue